// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostAction-moduleaction__NoyZh";
var _2 = "NewsboardPostAction-moduleactionIcon__k6qz6 IconNG-moduleiconContainer__SxWZ0";
var _3 = "NewsboardPostAction-moduleactionText__qNPXW";
var _4 = "NewsboardPostAction-modulecombinedAction__clEzC";
var _5 = "NewsboardPostAction-moduledisabledAction__x8PBd";
var _6 = "NewsboardPostAction-moduledisabledIcon__DfV5o";
export { _1 as "action", _2 as "actionIcon", _3 as "actionText", _4 as "combinedAction", _5 as "disabledAction", _6 as "disabledIcon" }
